/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PDialog from "../../../components/pos/PDialog";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { blue, grey } from "@mui/material/colors";
import PText from "../../../components/pos/PText";

const useStyles = makeStyles({});

const theme = createTheme({});

const ItemButton = withStyles((theme) => ({
  root: {
    width: "100%",
  },
}))(Button);

export default function CellEditor(props) {
  const { t } = useTranslation();
  const translate = t;

  const [name, setName] = useState();
  const [chairs, setChairs] = useState();

  useEffect(() => {
    if (props.currentCell) {
      setName(props.currentCell.cell.name);
      setChairs(props.currentCell.cell.chairs);
    }
  }, [props.currentCell]);

  function onSave() {
    props.updateCell(
      props.currentCell.rowIx,
      props.currentCell.colIx,
      name,
      chairs
    );
    props.closeWindow(false);
  }

  const content = (
    <div
      style={{
        padding: 10,
      }}
    >
      <Grid container spacing={"5px"}>
        <Grid item xs={6}>
          Name
        </Grid>
        <Grid item xs={6}>
          <PText value={name} onChange={(e) => setName(e.target.value)}></PText>
        </Grid>
        <Grid item xs={6}>
          Number of Chairs
        </Grid>
        <Grid item xs={6}>
          <PText
            value={chairs}
            type={"number"}
            onChange={(e) => setChairs(e.target.value)}
          ></PText>
        </Grid>
      </Grid>
    </div>
  );

  function onCloseWindow() {
    props.closeWindow(false);
  }

  return (
    <div>
      <PDialog
        content={content}
        title={"Edit Table"}
        maxWidth={"xs"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        custumClose={false}
        borderLess={false}
        onSave={onSave}
        saveLabel="OK"
      ></PDialog>
    </div>
  );
}
